import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, Dialog as DialogMui, IconButton, styled, Typography } from '@mui/material';

export const DialogContentWrapper = styled(Box)({
  padding: '20px',
  backgroundColor: 'white'
});

export const DialogContent = styled(Box)({
  backgroundColor: '#fff',
  display: 'flex',
  flexDirection: 'column',
  width: '632px',
  minHeight: '240px',
  padding: '40px 40px 0 40px',
  color: '#090909',
  cursor: 'default'
});

export const DialogScrollableContent = styled('div')({
  overflowY: 'auto',
  marginRight: '-40px',
  paddingRight: '40px'
});

export const DialogTitle = styled((props: any) => <Typography variant="h6" {...props} />)(() => ({
  color: '#090909',
  cursor: 'default',
  lineHeight: '1.2',
  paddingRight: '50px'
}));

export const DialogSubTitle = styled((props: any) => <div {...props} />)(() => ({
  marginTop: '10px',
  fontSize: '16px',
  color: '#090909',
  display: 'flex',
  width: '100%',
  lineHeight: '1.3rem'
}));

export const DialogToolbar = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  marginTop: 'auto',
  marginLeft: 'auto',
  padding: '30px 0',
  '& > button': {
    marginLeft: '15px',
    fontSize: '13px'
  },
  '& > div': {
    marginLeft: '15px',
    fontSize: '13px'
  }
});

export const CloseDialogButton = styled((props: any) => (
  <IconButton aria-label="close" sx={{ position: 'absolute', right: 8, top: 8 }} {...props}>
    <CloseIcon />
  </IconButton>
))(() => ({}));

export const CloseButton = styled((props: any) => (
  <Button variant="contained" disableElevation={true} {...props}>
    Cancel
  </Button>
))(() => ({}));

export const Dialog = styled(DialogMui)({
  '.MuiDialog-paper': {
    backgroundColor: '#FBFBFB',
    boxShadow: '0px 9px 46px 8px #0000001F, 0px 24px 38px 3px #00000024, 0px 11px 15px -7px #00000033',
    a: {
      textDecoration: 'underline'
    }
  },
  '.MuiDialogTitle-root': {
    paddingTop: 42,
    fontWeight: 500,
    fontSize: 22,
    color: '#000000'
  }
});

export const InfoList = styled('ul')({
  listStyleType: 'none',
  padding: 0,
  margin: 0,
  marginTop: '20px',
  fontSize: '14px',
  '& > li': {
    display: 'flex',
    alignItems: 'center',
    margin: '10px 0',
    '& > label': {
      fontWeight: 500,
      width: '70px',
      textAlign: 'right',
      marginRight: '6px'
    }
  }
});
